const MAX_ACTIVITY_DESCRIPTION = 250

export { MAX_ACTIVITY_DESCRIPTION }